import React from "react";

const ViewTemplateFooter = (props) => {
  return (
    <div className="footer d-flex">
      <button
        className="btn-tertiary cancel-button ml-auto"
        onClick={props.templateDeleteOpenHandler}
      >
        Delete
      </button>
     
        <button
          className="btn-primary create-button"
          onClick={(e) => props.templateEditHandler(e)}
        >
          Edit
        </button>
    
    </div>
  );
};

export default ViewTemplateFooter;


